var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('parliamentarian-position',{attrs:{"url":"HistoricalInformation/PrimeMinisters","pageHeader":"true","header":"Prime ministers"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }